const t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Greater Than Icon</title><desc>A picture showing the greater-than symbol.</desc><path d="M6 7.11L15.09 12 6 16.89V19l12-6.46v-1.08L6 5v2.11z"/></svg>';
export {
  t as default
};
